/* ==========================================================================
   Curtain Intro
   Vanilla JS, no dependencies. Wrapped in an IIFE.

   Note: the body.curtain-active class is added by an inline bootstrap
   script in sections/curtain-intro.liquid so the page never paints
   before transforms are applied. This file only handles dismissal.
   ========================================================================== */

(function () {
  'use strict';

  // Match the longest CSS transition (0.85s) with a small safety buffer.
  var ANIM_MS = 900;

  function init() {
    var curtain = document.getElementById('curtain-intro');
    if (!curtain) return;

    var showOnce = curtain.getAttribute('data-show-once') === 'true';

    // Skip the curtain entirely if we've already shown it this session.
    // (The inline bootstrap script also handles this, but check again here
    // in case the inline script was blocked or sessionStorage threw.)
    if (showOnce) {
      try {
        if (sessionStorage.getItem('curtainSeen')) {
          if (curtain.parentNode) curtain.parentNode.removeChild(curtain);
          return;
        }
      } catch (e) { /* fall through */ }
    }

    var closed = false;
    var removed = false;

    function closeCurtain() {
      if (closed) return;
      closed = true;

      // Trigger CSS-driven animations:
      //   - curtain.curtain-hidden     → curtain lifts off the top
      //   - body.curtain-closing       → header drops in from above,
      //                                  main rises up from below
      //
      // Note: we ADD curtain-closing rather than remove curtain-active.
      // Keeping curtain-active on through the animation means:
      //   1. Scroll stays locked (overflow: hidden) — wheel momentum from
      //      the dismissal can't scroll the page mid-animation.
      //   2. The transition/will-change rules stay scoped to .curtain-active,
      //      so once removeCurtain strips both classes, sections are
      //      completely clean — no lingering 0.85s transitions affecting
      //      scroll behavior or other transforms.
      curtain.classList.add('curtain-hidden');
      document.body.classList.add('curtain-closing');
      document.documentElement.classList.remove('curtain-arming');

      if (showOnce) {
        try { sessionStorage.setItem('curtainSeen', 'true'); } catch (e) {}
      }

      // Detach listeners so they can't fire mid-animation.
      curtain.removeEventListener('click', closeCurtain);
      curtain.removeEventListener('wheel', closeCurtain);
      curtain.removeEventListener('touchstart', closeCurtain);
      window.removeEventListener('keydown', onKeyDown);

      // Wait for the dismiss animation to complete, then remove the curtain
      // from the DOM entirely. We use transitionend rather than setTimeout
      // so the removal happens at the exact frame the animation ends — no
      // 50ms gap where sections briefly sit at the top of the viewport
      // before the page settles.
      var removeTimer = setTimeout(removeCurtain, ANIM_MS + 100); // safety fallback

      // Listen on the header section — it has the same 0.85s transition as
      // the other sections and is guaranteed to exist when the curtain is up.
      var headerSection = document.querySelector('.shopify-section-group-header-group')
                       || document.querySelector('#shopify-section-header');
      if (headerSection) {
        headerSection.addEventListener('transitionend', function onSectionTransitionEnd(e) {
          // Ignore other transitioning properties (e.g. opacity on hover states).
          if (e.propertyName !== 'transform') return;
          headerSection.removeEventListener('transitionend', onSectionTransitionEnd);
          clearTimeout(removeTimer);
          removeCurtain();
        });
      }
    }

    function onKeyDown(e) {
      // Dismiss on Esc, Enter, or Space — keyboard accessibility.
      if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        closeCurtain();
      }
    }

    function removeCurtain() {
      // Guard against double-invocation: transitionend fires first and clears
      // the safety setTimeout, but belt-and-suspenders in case both happen
      // to land on the same frame.
      if (removed) return;
      removed = true;

      // Strip both curtain classes so the body returns to a completely clean
      // state — no transitions, no will-change, no overflow lock, no
      // transforms. Other sections behave 100% normally from here on.
      document.body.classList.remove('curtain-active');
      document.body.classList.remove('curtain-closing');

      if (curtain && curtain.parentNode) {
        curtain.parentNode.removeChild(curtain);
      }
    }

    curtain.addEventListener('click', closeCurtain);
    curtain.addEventListener('wheel', closeCurtain, { passive: true });
    curtain.addEventListener('touchstart', closeCurtain, { passive: true });
    window.addEventListener('keydown', onKeyDown);
  }

  // Script is loaded with `defer`, so the DOM is parsed before init runs,
  // but guard anyway in case it's ever moved.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
